import { styled, FormControl } from "@mui/material";

export const FormControlStyled = styled(FormControl)(() => ({
  width: 260,
}));
